// extracted by mini-css-extract-plugin
export default {"window":"_3oiEDy2wCPqZXpO9nQUJX7"};